var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileImportDuotone1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1185 0V11H44.131L33.1185 0ZM25.5559 18.4766C24.7494 17.6709 23.4429 17.6709 22.6359 18.4766C21.8289 19.2822 21.8293 20.5872 22.6359 21.3933L26.0722 24.75H2.14572C1.00575 24.75 0.0808716 25.6781 0.0808716 26.8125C0.0808716 27.9469 1.00575 28.875 2.14572 28.875H26.0722L22.7142 32.2291C22.3038 32.6305 22.1059 33.1547 22.1059 33.6875C22.1059 34.2203 22.3076 34.7428 22.7108 35.1459C23.5174 35.9515 24.8239 35.9515 25.6309 35.1459L32.5137 28.2709C33.3203 27.4652 33.3203 26.1602 32.5137 25.3541L25.5559 18.4766Z",
    fill: "#3F3030"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.131 11V39.875C44.131 42.1532 42.2821 44 40.0013 44H15.2231C12.9432 44 11.0934 42.1523 11.0934 39.875V28.875H26.0722L22.7142 32.2291C22.3038 32.6305 22.1059 33.1547 22.1059 33.6875C22.1059 34.2203 22.3076 34.7428 22.7109 35.1459C23.5174 35.9515 24.8239 35.9515 25.6309 35.1459L32.5137 28.2709C33.3203 27.4652 33.3203 26.1602 32.5137 25.3541L25.6309 18.4791C24.8243 17.6735 23.5179 17.6735 22.7109 18.4791C21.9038 19.2848 21.9043 20.5898 22.7109 21.3959L26.0722 24.75H11.0934V4.125C11.0934 1.8468 12.9432 0 15.2231 0H33.1185V11H44.131Z",
    fill: "#3F3030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.0501,
    height: 44,
    fill: "white",
    transform: "translate(0.0808716)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImportDuotone1);
export default __webpack_public_path__ + "static/media/file-import-duotone 1.dd5a6387034457d1b109a2c9d370c565.svg";
export { ForwardRef as ReactComponent };